const METHOD_NAMES = {
  Visa: 'visa',
  MasterCard: 'mastercard',
  Discover: 'discover',
  'American Express': 'amex',
  'Apple Pay': 'apple-pay',
  'Google Pay': 'google-pay'
};

export default METHOD_NAMES;



// WEBPACK FOOTER //
// ./shared/components/payment/methodNames.js